import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useAlert } from 'react-alert'

import { GetApi } from '../../Common/ApiAxios'
import { SetLoadSpinner } from '../../Common/Slice/LoadSpinnerSlice'
import ErrorHandling from '../../Common/ErrorHandling'
import FUNC from '../../Common/FunctionEnum'
import { createOrderInfo } from '../../Common/Utilties/ObjectUtitlity'

import MasterPanelWrap from '../Wrap/MasterPanelWrap'
import MasterFlexWrap from '../Wrap/MasterFlexWrap'
import MasterListView from '../Molcules/MasterListView'
import Search from './Search'
import OrderDetail from './OrderDetail'

import MasterSelect from '../MasterSelect'
export const DefaultUrl = '/api/masterManagement/order'

const Order = (props) => {
    const agreementDateRef = useRef()
    const [dataList, setDataList] = useState([])
    const [detail, setDetail] = useState(null) // 未選択状態
    const [selectedId, setSelectedId] = useState(null)
    const [searchOption, setSearchOption] = useState({ orderId: '', orderName: '' })
    const { loginUserInfo } = useSelector(state => state)
    const [pagenation, setPagenation] = useState({})
    const dispatch = useDispatch()
    const alert = useAlert()
    const grants = loginUserInfo.menuList && loginUserInfo.menuList.find(menu => menu.functionMenuId === FUNC.ORDER)

    const [postCompanyList,setPostCompanyList] = useState(new Array())
    const [postCustomerList,setPostCustomerList] = useState(new Array())
    //会社・顧客検索処理
    const setPost=()=>{
      const serachCompany = async()=>{
        const result = await GetApi('/api/masterManagement/company', {companyId:'',companyName:'',page: 1})
        if (result.errorDetail) {
          ErrorHandling(result, alert)
          return null
        }
        const resultList = result.data.responseList.map(item => {
          // return {
          //   index: item.companyId,
          //   name: item.companyName+'('+item.companyId+')',
          // }
          return <><option value={item.companyId} >{item.companyName+'('+item.companyId+')'}</option></> 
        })

        setPostCompanyList(resultList)
        return true
      }
      const serachCustomer = async()=>{
        const result = await GetApi('/api/masterManagement/customer', {customerId:'',customerName:'',page: 1})
        if (result.errorDetail) {
          ErrorHandling(result, alert)
          return null
        } 
        const resultList = result.data.responseList.map(item => {
          // return {
          //   index: item.customerId,
          //   name: item.customerName+'('+item.customerId+')',
          // }
          return <><option value={item.customerId} >{item.customerName+'('+item.customerId+')'}</option></> 
        })
        
        setPostCustomerList(resultList)
        return true
      }
      serachCompany()
      serachCustomer()
    }

    const selectItem = async (id) => {
      dispatch(SetLoadSpinner(true))
      setSelectedId(id)
      const result = await GetApi(`${DefaultUrl}/${id}`)
      dispatch(SetLoadSpinner(false))
      ErrorHandling(result, alert) || setDetail(result.data)
    }

    // 新規登録用初期化処理
    const createNew = (e) => {
      setDetail(createOrderInfo()) // 新規作成時の値
      setSelectedId(null)
    }

    // 検索APIの実行
    const onSearch = async (createId, page) => {
      dispatch(SetLoadSpinner(true))
      setSearchOption(
        {
          agreementDt: agreementDateRef.current,
        }
      )
      const data = {
        agreementDt: agreementDateRef.current,
        page: page
      }
      const result = await GetApi(DefaultUrl, data)
      dispatch(SetLoadSpinner(false))
      if (result.errorDetail) {
        ErrorHandling(result, alert)
        return null
      } else {
        const resultList = result.data.responseList.map(item => {
          return {
            index: item.orderId,
            id: item.orderId,
            name: item.occupation
          }
        })
        setDataList(resultList)
        setPagenation(result.data)
        setSelectedId(null)
        setDetail(null) // 未選択状態
      }
    }
    const onKeyDown = (event) => {
      if (event.keyCode === 13) {
        onSearch(null, 1)
      }
    }

    const pageSelectFunc = (pageId) => {
      onSearch(null, pageId)
    }

    useEffect(() => {
      if (grants)
        document.title = grants.functionMenuName + ' | Core Time Cloud'
      else
        document.title = 'Core Time Cloud'
    }, [grants])

    //画面表示の時
    useEffect(()=>{
      onSearch(null,1)
      setPost()
    },[])

    if (!agreementDateRef.current) {
      var today = new Date();
      agreementDateRef.current = today.getFullYear() + '-' + ('00' + (today.getMonth() + 1)).slice(-2) + '-01'
    }

    if (!grants) return null
    return (
        <MasterPanelWrap id='OrderWrap'>
        <Search
          title={grants.functionMenuName}
          showButton
          onClick={() => onSearch(null, 1)}
          onKeyDown={(e) => onKeyDown(e)}
          agreementDateRef={agreementDateRef}
          grants={grants}
        >
        </Search>
        <MasterFlexWrap>
            <MasterSelect/>
            <MasterListView
              dataList={dataList}
              setSelectedId={setSelectedId}
              selectFunction={(id) => selectItem(id)}
              createFunction={() => createNew()}
              canWrite={grants.writeGrantDivision === 2 || grants.writeGrantDivision === 1}
              pageSelectFunc={pageSelectFunc}
              pagenation={pagenation}
              isIdView
            />
            <OrderDetail
              onSearch={onSearch}
              setSelectedId={setSelectedId}
              setDetail={setDetail}
              orderDetail={detail}
              postCustomerList={postCustomerList}
              postCompanyList={postCompanyList}
            >
            </OrderDetail>
        </MasterFlexWrap>
        </MasterPanelWrap>
    )
}

export default Order
